import {
  DataCatalogApolloClient,
  VizClientDataCatalogProvider,
} from '@tableau/data-catalog-shared';
import { SiteUrls } from '@tableau/shared-urls';
import { VizPortalWebClientRequester } from '@tableau/vizportal-webclient-api';
import * as React from 'react';
import { ViewDetailsByPathWrapper } from './ViewDetailsByPathWrapper';

export type EmbeddableVizClientLineagePanelProps = {
  readonly client: DataCatalogApolloClient;
  readonly siteUrlName: string;
  readonly queryString: string;
  readonly sheetPath: string;
  readonly testId: string;
  readonly onCloseRequested: () => void;
  readonly lastRefreshKey?: string;
  readonly vizPortalWebClientRequester: VizPortalWebClientRequester;
  readonly writableFieldDescriptionsEnabled: boolean;
  readonly markupEditingEnabled: boolean;
};

export class EmbeddableVizClientLineagePanel extends React.Component<
  EmbeddableVizClientLineagePanelProps
> {
  public render(): JSX.Element {
    return (
      <VizClientDataCatalogProvider
        client={this.props.client}
        siteUrls={
          new SiteUrls({
            siteUrlName: this.props.siteUrlName,
            queryString: this.props.queryString,
          })
        }
        featureFlags={{
          metricsDataCatalogEnabled: false, // feature flag is unused in VizClient
          writableFieldDescriptionsEnabled: this.props
            .writableFieldDescriptionsEnabled,
          markupEditingEnabled: this.props.markupEditingEnabled,
          personalSpaceEnabled: false,
          dqcertificationVisualDesignEnabled: true,
          fieldDescriptionInheritanceLineageEnabled: false, // Flag is not used in the lineage panel
          incompleteCustomSqlEnabled: false,
          publishedConnectionsLineageEnabled: true,
          databasesInProjectsEnabled: false // flag unused in vizclient
        }}
      >
        <ViewDetailsByPathWrapper
          viewPath={this.props.sheetPath}
          testId={this.props.testId}
          onCloseRequested={this.props.onCloseRequested}
          lastRefreshKey={this.props.lastRefreshKey}
          vizPortalWebClientRequester={this.props.vizPortalWebClientRequester}
        />
      </VizClientDataCatalogProvider>
    );
  }
}
